/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/',
    name: 'Dashboard',
    slug: 'home',
    icon: 'HomeIcon',
    i18n: 'Dashboard',
    permissions: 'public',
  },
  {
    header: 'User Settings',
    icon: 'ArchiveIcon',
    items: [
      {
        url: '/pages/manage-nimble/users',
        name: 'L1 Users',
        slug: 'users',
        icon: 'UserIcon',
        i18n: 'User',
        permissions: 'view-user,create-user,view-user-role,create-user-role',
      },
    ]
  },
  {
    header: 'L2 Settings',
    icon: 'ArchiveIcon',
    items: [
      {
        url: '/pages/tenants',
        name: 'Tenants',
        slug: 'tenants-list',
        icon: 'HomeIcon',
        i18n: 'Tenants',
        permissions: 'view-tenant,create-tenant',
      },
      {
        url: '/pages/prospect-customers',
        name: 'Prospect Customers',
        slug: 'prospect-customers',
        icon: 'UsersIcon',
        i18n: 'Tenants',
        permissions: 'view-prospect-customer,create-prospect-customer',
      },
      {
        url: '/pages/pricing-tiers',
        name: 'Pricing',
        slug: 'manage-pricing-tiers',
        icon: 'DollarSignIcon',
        i18n: 'Pricing',
        permissions: 'view-pricing-tier,create-pricing-tier',
      },
      {
        url: '/pages/channel-partners',
        name: 'Channel Partners',
        slug: 'manage-channel-partners',
        icon: 'UsersIcon',
        i18n: 'Channel Partners',
        permissions: 'view-channel-partner,create-channel-partner',
      }
    ],
  },
  {
    header: 'System Settings',
    icon: 'ArchiveIcon',
    items: [
      {
        url: '/pages/product-communications',
        name: 'In Product Communications',
        slug: 'in-product-communications',
        icon: 'MessageCircleIcon',
        i18n: 'In Product Communication',
        permissions: 'view-channel-partner,create-channel-partner',
      },
      {
        url: '/pages/external-services',
        name: 'External Services',
        slug: 'external-services',
        icon: 'ServerIcon',
        i18n: 'External Services',
        permissions: 'public',
      }
    ]
  },
  {
    header: 'HELP GUIDE',
    icon: 'ArchiveIcon',
    items: [
      {
        url: '/pages/help-tags',
        name: 'Guide List',
        slug: 'manage-help-tags',
        icon: 'InfoIcon',
        i18n: 'Help Tags',
        permissions: 'view-helper-tag,create-helper-tag',
      },
      {
        url: '/pages/help-tags-categories',
        name: 'Guide Categories',
        slug: 'manage-help-tags-categories',
        icon: 'TagIcon',
        i18n: 'Help Tags',
        permissions: 'view-helper-tag,create-helper-tag',
      },
      {
        url: '/pages/settings',
        name: 'Settings',
        slug: 'settings',
        icon: 'SettingsIcon',
        i18n: 'Help Tags',
        permissions: 'view-helper-tag,create-helper-tag',
      }
    ]
  }
]
